import script from "./AssessmentAudioRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentAudioRecorder.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentAudioRecorder.vue?vue&type=style&index=0&id=07e34788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e34788"]])

export default __exports__